import React, { CSSProperties, PropsWithChildren } from 'react';

import { cn } from '../../../../../helpers/classBuilders';
import { componentName } from '../constants';

interface Props extends PropsWithChildren {
  getStyles: CSSProperties;
  isPreview: boolean;
  className?: string;
}

export const Layout = ({
  getStyles,
  children,
  isPreview,
  className,
}: Props) => {
  return (
    <div
      className={cn(
        componentName,
        'flex-1',
        {
          'overflow-y-auto': isPreview,
        },
        className,
      )}
      style={getStyles}
    >
      {children}
    </div>
  );
};
